import { useEffect, useRef } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import api from '../services/api';

export default function AuthCallback() {
  const navigate = useNavigate();
  const location = useLocation();
  const { setUserData, setTokenData } = useAuth();
  const hasProcessed = useRef(false);

  useEffect(() => {
    // Use useRef for the processed flag to prevent race conditions under StrictMode
    if (hasProcessed.current) return;
    hasProcessed.current = true;

    const processSession = async () => {
      // Extract session_id from URL fragment
      const hash = location.hash;
      const sessionIdMatch = hash.match(/session_id=([^&]+)/);
      
      if (!sessionIdMatch) {
        navigate('/login');
        return;
      }

      const sessionId = sessionIdMatch[1];

      try {
        const response = await api.exchangeSession(sessionId);
        const { token, ...userData } = response.data;
        
        // Store JWT token in localStorage for API authentication
        if (token) {
          setTokenData(token);
        }
        
        setUserData(userData);
        
        // Clear the hash and navigate to dashboard
        window.history.replaceState(null, '', window.location.pathname);
        navigate('/dashboard', { state: { user: userData }, replace: true });
      } catch (error) {
        console.error('Session exchange failed:', error);
        navigate('/login');
      }
    };

    processSession();
  }, [location, navigate, setUserData, setTokenData]);

  return (
    <div className="min-h-screen bg-[#F8F6FF] flex items-center justify-center">
      <div className="glass-card p-8 rounded-3xl">
        <div className="flex items-center gap-4">
          <div className="w-8 h-8 border-4 border-[#5B21B6] border-t-transparent rounded-full animate-spin" />
          <span className="text-[#1E1B4B] font-medium">Completing sign in...</span>
        </div>
      </div>
    </div>
  );
}
